// src/admin/AuthRoute.jsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';

const AuthRoute = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div>Завантаження...</div>;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/infoplace/login" />;
};

export default AuthRoute;
